import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { PartyVisitsYears } from './party-visits.model';
import { HttpParams } from '@angular/common/http';
import { buildHttpParams } from '../utils';
import { PaginatedResponse } from '../common/models/common.model';
import { PartyVisit } from '../attendance/attendance.model';

@Injectable({
  providedIn: 'root',
})
export class PartyVisitsService {
  private baseUrl: string = 'attendance/admin/party-visits/';

  constructor(private apiService: ApiService) {}

  public years(): Observable<PartyVisitsYears> {
    return this.apiService.get(this.baseUrl + 'years/');
  }

  public party_visits(q = {}): Observable<PaginatedResponse<PartyVisit>> {
    const params = buildHttpParams(q);
    return this.apiService.get(this.baseUrl, params);
  }
}
